import { EdgeDisplayData, NodeDisplayData } from 'sigma/types';
// import internal from 'stream';

export interface NodeData {
  key: string;
  label: string;
  tag: string;
  URL: string;
  cluster: string;
  x: number;
  y: number;
}

export interface Cluster {
  key: string;
  color: string;
  clusterLabel: string;
}

export interface Tag {
  key: string;
  image: string;
}

export interface Dataset {
  nodes: NodeData[];
  edges: [string, string][];
  clusters: Cluster[];
  tags: Tag[];
}

export interface FiltersState {
  tags: Record<string, boolean>;
}

export interface DateState {
  min: number;
  max: number;
  date: number;
}

export interface WymmoDirectory {
  tags: WymmoTag[];
  items: WymmoItem[];
}

// SAME VALUES FROM directory.rs
export enum TagGroup {
  GROUPS = "groups",
  B2B_SAAS = "b2bsaas",
  ONLINE_SERVICES = "onlineservices",
  AUDIT_SERVICES = "auditservices",
  FIN_SERVICES = "finservices",
  LEGAL_SERVICES = "legalservices",
  BUILDERS = "builders",
  AGENTS = "agents",
}

export function get_tag_group_color(tag_group: TagGroup): string {
  // nice palette : https://coolors.co/palette/001219-005f73-0a9396-94d2bd-e9d8a6-ee9b00-ca6702-bb3e03-ae2012-9b2226
  // or this one : https://coolors.co/palette/f94144-f3722c-f8961e-f9844a-f9c74f-90be6d-43aa8b-4d908e-577590-277da1

  if (tag_group === TagGroup.GROUPS) return "#f94144";
  if (tag_group === TagGroup.B2B_SAAS) return "#f3722c";
  if (tag_group === TagGroup.ONLINE_SERVICES) return "#f8961e";
  if (tag_group === TagGroup.AUDIT_SERVICES) return "#f9844a";
  if (tag_group === TagGroup.FIN_SERVICES) return "#90be6d";
  if (tag_group === TagGroup.LEGAL_SERVICES) return "#4d908e";
  if (tag_group === TagGroup.BUILDERS) return "#577590";
  if (tag_group === TagGroup.AGENTS) return "#277da1";


  return ""
}

export interface WymmoTag {
  tag_group: TagGroup;
  key: string;
  title: string;
  description: string[];
  icon?: string;
}

export interface WymmoItem {
  key: string;
  name: string;
  title: string;
  tags: string[];
  created_in: number;
  concluded_in: number;
  description: string[];
  url: string;
  backlink?: string;
  icon?: string;
  links: WymmoItemLink[];
  events: WymmoItemEvent[];
}

export interface WymmoItemLink {
  target_key: string;
  begin_in: number;
  end_in: number | null;
  description: string;
}

export interface WymmoItemEvent {
  happened_in: number;
  description: string;
}

export const WYMMO_TAG = 'Tag';
export type WymmoTagType = typeof WYMMO_TAG;
export const WYMMO_ITEM = 'Société';
export type WymmoItemType = typeof WYMMO_ITEM;

export type WymmoType = WymmoTagType | WymmoItemType;

export type SigmaItemNode = NodeDisplayData & {
  label: string;
  wymmoType: WymmoItemType;
  wymmoAttributes: WymmoItem;
  wymmoTagLabels: string[];
};
export type SigmaTagNode = NodeDisplayData & {
  label: string;
  wymmoType: WymmoTagType;
  wymmoAttributes: WymmoTag;
};
export type SigmaNode = SigmaItemNode | SigmaTagNode;

export const WYMMO_HAS_TAG = 'A tag';
export type WymmoHasTagType = typeof WYMMO_HAS_TAG;
export const WYMMO_IS_LINKED = 'Est lié à';
export type WymmoIsLinkedType = typeof WYMMO_IS_LINKED;

export type SigmaHasTagEdge = EdgeDisplayData & {
  wymmoType: WymmoHasTagType;
};
export type SigmaIsLinkedEdge = EdgeDisplayData & {
  wymmoType: WymmoIsLinkedType;
  wymmoAttributes: WymmoItemLink;
};
export type SigmaEdge = SigmaHasTagEdge | SigmaIsLinkedEdge;
